<template>
<div >
    <div v-bind:class="{'pet-wrapper':showDetails}">
        <div class="media-body">
            <div class="media-left">
                <img :src="profilePhotoPathComp"  alt="" class="media-object img-responsive img-rounded" style="min-width:60px; min-height:60px; border: 1px solid #c3c3c3;" height="80" width="80"></img>
            </div>
            
            <div class="media-left">
                <h4<h4 class="media-heading main-name" style="padding-bottom:0px;margin-bottom:3px;"> <strong> {{petComp.Name}}</strong></h4>
                <h5 style="padding-top:0px;margin-top:0px;padding-bottom:0px;; margin-bottom:3px;" class="text-muted"> </i> {{ageToString(petComp)}}</h5>
                <h5 style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;">{{genderToString(petComp.Gender)}} {{petTypeToString(petComp.PetType)}}</h5>
            </div>
            </div>
            <div class="media-right media-bottom">
                <button class="btn btn-default " v-if="showDetails" @click="viewPet()">View Profile</button>
                <PetDetailsView v-if="viewPetModal" :petId="petId"></PetDetailsView>
            </div>
    
        
    </div>
</div>
</template>

<script>
const API_URL = "https://www.dupaws.com/services/"
import PetDetailsView from './PetDetailsView'

export default {
    name: '' , 
    props: ['petId','showDetails'],
    data() {
        return {
            petData: '',
            profilePhotoPath: '',
            viewPetModal: false
        }
    },
    methods:{
        updatePetDetails: function(){
            this.$router.push({path: 'updatePet/' + this.petId })
        },
        genderToString: function(gender){
            if (gender==1)
            return "Male"
            else
            return "Female"
        },
        petTypeToString: function(petType){
            if (petType==1)
                return "Dog"
            else if (petType==2)
                return "Cat"
            else 
                return "Unknown"
        },
        viewPet: function(){
            if (this.viewPetModal==false)
                this.viewPetModal=true
            else 
                this.viewPetModal==false
        },
        ageToString: function(petData){
            var ageYears = petData.AgeYears
            var ageMonths = petData.AgeMonths
            if ((ageYears ===null || ageYears==0) && (ageMonths===null||ageMonths==0))
                return "Age not set"
            if (ageMonths===null || ageMonths==0)
                return ageYears + " years"
            else if (ageYears===null || ageYears==0)
                return ageMonths + " months"
            else 
                return ageYears + " years " + ageMonths + " month"
            
        },
  
        
    },
    components: {
        PetDetailsView
    },
    mounted: function(){
       var self =this;
       $.ajax({
            type: 'GET',
            url: API_URL + "api/getPetData/" + self.petId,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            dataType: "json",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                self.petData = data  
            },
            error: function(data, status, error) {
                console.log("failed to get Sitter Location" + data.responseText)
            }
    })   

    },
    computed: {
        petComp: function(){
            var self = this
            return self.petData
        },
        profilePhotoPathComp: function(){
            var self=this;
            if(self.petComp.PetPhotoDtos){
                if (self.petComp.PetPhotoDtos.length>0)
                return self.petComp.PetPhotoDtos[0].Path
                else
                return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png"
            } else 
                return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png"
            
        }
    }
}

</script>


<style scoped>

.pet-wrapper{
    margin:5px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    border-radius: 5px;
    padding:10px;
}

</style>


// WEBPACK FOOTER //
// PetSelectCard.vue?07e28fc9